import { extend } from 'vee-validate';
import { required, excluded, max } from 'vee-validate/dist/rules';
import { __ } from '~/javascripts/lib/locale';
import { noEmoji } from './rules/no_emoji';
import { validEmail } from './rules/valid_email';
import { noDoubleQuotes } from './rules/no_double_quotes';

export default function initValidation() {
  extend('noEmoji', noEmoji);
  extend('validEmail', validEmail);
  extend('noDoubleQuotes', noDoubleQuotes);
  extend('required', {
    ...required,
    message: __('{_field_} is required.'),
  });
  extend('excluded', {
    ...excluded,
  });
  extend('max', {
    ...max,
    message: '{_field_} must be {length} characters or less.',
  });
}
